<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <form @submit.prevent="validateForm">
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Código</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el código"
                v-model.trim="notification.code"
                @input="clearError('code')"
                disabled="true"
              />
              <div v-if="errors.ruc" class="input-error">{{ errors.code }}</div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Asunto</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el asunto"
                v-model.trim="notification.subject"
                @input="clearError('subject')"
              />
              <div class="input-error">{{ errors.subject }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Tipo</label>
              <select
                v-model="notification.type"
                class="form-select form-control h-55"
                aria-label="Default select example"
                disabled="true"
              >
                <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                <option
                  :value="notificationType.id"
                  v-for="(notificationType, i) of itemsNotificationTypes"
                  :key="i"
                >
                  {{ notificationType.name }}
                </option>
              </select>
              <div class="input-error">{{ errors.type }}</div>
            </div>
          </div>
          <div
            class="col-lg-4 col-sm-6"
            v-if="notification.type != NOTIFICATION_TYPE_EMAIL"
          >
            <div class="form-group mb-4">
              <label class="label text-secondary">Icono</label>
              <br />
              <div class="d-flex gap-3">
                <div
                  v-for="icon in NOTIFICATION_ICONS"
                  :key="icon.key"
                  class="icon-option"
                  :class="{ selected: notification.icon === icon.key }"
                  @click="selectIcon(icon.key)"
                >
                  <img :src="getIcon(icon.key)" class="icon-img" />
                  <small>{{ icon.label }}</small>
                </div>
              </div>
              <div class="input-error">{{ errors.icon }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-lg-8 col-sm-6"
            v-show="notification.type == NOTIFICATION_TYPE_EMAIL"
          >
            <div class="form-group mb-4">
              <label class="label text-secondary">Contenido</label>
              <TextEditor
                class="text-editor"
                v-model="notification.htmlContent"
                :placeholder="'Ingrese el contenido'"
                @change="clearError('htmlContent')"
              />
              <div class="input-error">{{ errors.htmlContent }}</div>
            </div>
          </div>

          <div
            class="col-lg-8 col-sm-6"
            v-show="notification.type != NOTIFICATION_TYPE_EMAIL"
          >
            <div class="form-group mb-4">
              <label class="label text-secondary">Contenido</label>

              <textarea
                v-show="notification.type != NOTIFICATION_TYPE_EMAIL"
                rows="4"
                style="resize: none"
                class="form-control text-dark no-resize"
                placeholder="Ingresar el contenido"
                v-model.trim="notification.txtContent"
                @input="clearError('txtContent')"
              ></textarea>
              <div class="input-error">{{ errors.txtContent }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Torneo</label>
              <select
                class="form-select form-control h-45"
                aria-label="Default select example"
                v-model="notification.tournamentId"
                @click="clearPlayer()"
              >
                <option :value="null">-- Seleccionar --</option>
                <option
                  :value="tourney.id"
                  v-for="(tourney, i) of itemsTournament"
                  :key="i"
                >
                  {{ tourney.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Jugador</label>
              <input
                v-model="notification.playerFullName"
                @input="fetchResults"
                type="text"
                class="form-control"
                placeholder="Escribe para buscar jugadores..."
              />

              <ul
                v-if="showDropdown && results.length"
                class="dropdown-menu show w-100 mt-1"
              >
                <li
                  v-for="item in results"
                  :key="item.id"
                  class="dropdown-item"
                  @click="selectItem(item)"
                >
                  {{ item.fullName }}
                </li>
              </ul>
              <div class="input-error">{{ errors.matchId }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group mb-4">
              <label class="label text-secondary">Multimedia</label>
              <div v-if="notification.multimedia">
                <img
                  :src="notification.multimedia"
                  alt="Portada de Torneo"
                  class="img-fluid mb-2 d-block"
                />
                <button @click.prevent="removeCoverFile" class="btn btn-danger">
                  Eliminar multimedia
                </button>
              </div>
              <FilePond
                name="fileCover"
                :maxFileSize="'2MB'"
                :accepted-file-types="supportedFormats"
                allow-multiple="false"
                :max-files="1"
                label-idle="Arrastra tu imagen o <span class='filepond--label-action'>Buscar</span>"
                :labelMaxFileSizeExceeded="'El archivo es demasiado grande'"
                :labelMaxFileSize="'El tamaño máximo permitido es {filesize}'"
                :labelFileTypeNotAllowed="'El archivo tiene una extensión no permitida'"
                :fileValidateTypeLabelExpectedTypes="`Los tipos de archivo permitidos son: ${supportedFormats.join(
                  ', '
                )}`"
                credits=""
                @updatefiles="handleUpdateFiles"
                @input="clearError('fileCover')"
                v-if="!notification.multimedia"
              />
              <div class="input-error">{{ errors.fileCover }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="d-flex flex-wrap gap-3">
              <RouterLink to="/notifications">
                <button
                  type="button"
                  class="btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                >
                  Cancelar
                </button>
              </RouterLink>
              <button
                class="btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4"
                type="submit"
                :disabled="isLoading"
              >
                <span v-if="!isLoading">{{
                  notification.id == 0 ? "Crear" : "Actualizar"
                }}</span>
                <span
                  class="spinner-border spinner-border-sm me-2"
                  aria-hidden="true"
                  v-if="isLoading"
                ></span>
                <span role="status" v-if="isLoading">Procesando...</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { notificationSchema } from "@/schemas/notificationSchema";
import { defineComponent, ref, onMounted } from "vue";
import api from "@/services/api";
import { useToast } from "vue-toastification";
import { useRouter, useRoute } from "vue-router";
import { LABELS, NOTIFICATION_TYPE } from "@/utils/constants";
import TextEditor from "@/components/Common/TextEditor.vue";

import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Create FilePond component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview
);

export default defineComponent({
  name: "CreateNotification",
  components: { TextEditor, FilePond },
  setup() {
    const toast = useToast();
    const route = useRoute();
    const router = useRouter();
    const isLoading = ref(false);
    const NOTIFICATION_TYPE_EMAIL = NOTIFICATION_TYPE.EMAIL;
    const itemsNotificationTypes = ref<any[]>([]);
    const notification = ref({
      id: 0,
      subject: null,
      type: 0,
      htmlContent: "",
      txtContent: "",
      code: "",
      icon: "",
      multimedia: null,
      fileCover: null,
      tournamentId: null,
      playerId: null,
      playerFullName: "",
    });
    const errors = ref<Record<string, string>>({});
    const NOTIFICATION_ICONS = [
      { key: "wait", label: "Espera" },
      { key: "alert", label: "Alerta" },
      { key: "x", label: "Error" },
      { key: "question", label: "Pregunta" },
      { key: "check", label: "Correcto" },
    ];
    const supportedFormats = ["image/jpg", "image/jpeg", "image/png"];
    const itemsTournament = ref<any[]>([]);
    const results = ref<any[]>([]);
    const showDropdown = ref(false);
    let timeout: number;
    onMounted(async () => {
      await getTournament();
      await getNotificationTypes();
      var id = route.params.id;
      if (id) {
        await getnotificationById(id);
      }
    });

    const getIcon = (icon: string) => {
      try {
        return require(`@/assets/images/notification-status-${icon}.png`);
      } catch (e) {
        return require("@/assets/images/notification-status-check.png");
      }
    };
    const selectIcon = (iconKey: string) => {
      notification.value.icon = iconKey;
    };
    const getNotificationTypes = async () => {
      try {
        const response = await api.get(`/common/notification-type`);
        itemsNotificationTypes.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };
    const clearError = (field: string) => {
      errors.value[field] = "";
    };

    const getnotificationById = async (id: any) => {
      try {
        const response = await api.get(
          `/notification/configuration-notification/${id}`
        );
        if (response.data.multimedia) {
          response.data.multimedia =
            process.env.VUE_APP_API_URL + "/" + response.data.multimedia;
        }
        notification.value = response.data;
        notification.value.txtContent = response.data.htmlContent;
      } catch (ex) {
        console.error(ex);
      }
    };
    const validateForm = async () => {
      try {
        errors.value = {};
        await notificationSchema.validate(notification.value, {
          abortEarly: false,
          context: {
            type: notification.value.type,
          },
        });
        isLoading.value = true;

        await createNotification();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };

    const createNotification = async () => {
      try {
        const payload = {
          ...notification.value,
          htmlContent:
            notification.value.type == NOTIFICATION_TYPE_EMAIL
              ? notification.value.htmlContent
              : notification.value.txtContent,
        };

        const formData = buildFormData(payload);

        const response: any = await api.postForm(
          `/notification/configuration-notification`,
          formData
        );

        if (response.data.return) {
          toast.success(
            `La notificación fue ${
              notification.value.id == 0 ? "creada" : "actualizada"
            } con éxito.`,
            {
              timeout: 2000,
            }
          );

          router.push({ name: "NotificationsPage" });
        }
      } catch (ex) {
        toast.error("La notificación no pudo ser creado.", {
          timeout: 2000,
        });
        console.error(ex);
      }
    };
    const removeCoverFile = async () => {
      notification.value.multimedia = null;
    };
    const handleUpdateFiles = (fileItems: any[]) => {
      notification.value.fileCover = fileItems.length
        ? fileItems[0].file
        : null;
    };
    const buildFormData = (data: any) => {
      const formData = new FormData();
      for (const key in data) {
        if (
          data[key] !== undefined &&
          data[key] !== null &&
          key != "createdBy"
        ) {
          formData.append(key, data[key]);
        }
      }
      return formData;
    };
    const getTournament = async () => {
      try {
        var params = `pageNumber=1&pageSize=99999&isActive=true`;

        const response = await api.get(`/tournament?${params}`);

        itemsTournament.value = response.data.list;
      } catch (error) {
        console.error(error);
      }
    };
    const fetchResults = () => {
      clearTimeout(timeout);
      notification.value.playerId = null;
      if (
        notification.value.tournamentId == null ||
        !notification.value.playerFullName ||
        notification.value.playerFullName.length < 2
      ) {
        results.value = [];
        showDropdown.value = false;
        return;
      }

      timeout = window.setTimeout(async () => {
        try {
          const response = await api.get(`/player/search-player`, {
            params: {
              tournamentId: notification.value.tournamentId,
              query: notification.value.playerFullName,
            },
          });

          results.value = response.data;
          showDropdown.value = true;
        } catch (error) {
          console.error("Error fetching data", error);
          showDropdown.value = false;
        }
      }, 300);
    };
    const selectItem = async (item: any) => {
      isLoading.value = true;
      notification.value.playerId = item.id;
      notification.value.playerFullName = item.fullName;
      isLoading.value = false;
      showDropdown.value = false;
    };
    const clearPlayer = async (item: any) => {
      notification.value.playerId = item.id;
      notification.value.playerFullName = item.fullName;
    };

    return {
      createNotification,
      validateForm,
      clearError,
      notification,
      itemsNotificationTypes,
      errors,
      isLoading,
      NOTIFICATION_TYPE_EMAIL,
      LABELS,
      getIcon,
      selectIcon,
      NOTIFICATION_ICONS,
      supportedFormats,
      removeCoverFile,
      handleUpdateFiles,
      itemsTournament,
      results,
      showDropdown,
      fetchResults,
      selectItem,
      clearPlayer,
    };
  },
});
</script>
<style>
.icon-option {
  cursor: pointer;
  text-align: center;
  padding: 8px;
  border: 2px solid transparent;
  border-radius: 10px;
  transition: 0.2s;
}

.icon-option:hover {
  border-color: #ccc;
}

.icon-option.selected {
  border-color: #007bff;
  background-color: #e7f1ff;
}

.icon-img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}
</style>